/**
 * @file Web Gallery Blog Listing component.
 */

import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

import Spinner from '../../../components/global/Spinner';
import WebGalleryBlogPostCard from './WebGalleryBlogPostCard';
import { getWebGalleryBlogPath } from '../utilities/web-galleries';
import WebGalleryBlogToolbar from './WebGalleryBlogToolbar';
import Button from '../../../components/global/Button';

const propTypes = {
  loading: PropTypes.bool,
  loadingEntity: PropTypes.bool,
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }),
  blogPosts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  fetchingMore: PropTypes.bool,
  fetchMore: PropTypes.func,
  total: PropTypes.number,
  authenticated: PropTypes.bool,
  blogPostViewsCreate: PropTypes.func,
};

const WebGalleryBlogListing = ({
  entity,
  loading,
  loadingEntity,
  blogPosts,
  fetchingMore,
  fetchMore,
  total,
  authenticated,
  blogPostViewsCreate,
}) => {
  if (loading || loadingEntity) {
    return (
      <div className="d-flex mt-4">
        <Spinner className="m-auto" />
      </div>
    );
  }

  useEffect(() => {
    const unreadBlogPostsIds = blogPosts
      .filter(blogPost => !blogPost.is_viewed)
      .map(({ id }) => id);

    if (unreadBlogPostsIds.length > 0 && authenticated) {
      blogPostViewsCreate(unreadBlogPostsIds);
    }
  }, [false]);

  const blogUrl = getWebGalleryBlogPath(entity);

  return (
    <Fragment>
      <WebGalleryBlogToolbar entity={entity} />
      <div className="container-fluid" data-testId="web-gallery-blog-listing">
        <div className="row">
          <div className="col-12 my-5">
            <div className="blog-list-grid">
              {blogPosts.map(blogPost => (
                <WebGalleryBlogPostCard
                  key={blogPost.id}
                  blogPost={blogPost}
                  linksTo={blogUrl}
                />
              ))}
            </div>
            {total > blogPosts.length && (
              <div className="text-center mt-5">
                <Button btnSize="sm" className="px-5" onClick={fetchMore}>
                  {fetchingMore ? 'Loading…' : 'Load more'}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

WebGalleryBlogListing.propTypes = propTypes;

export default WebGalleryBlogListing;
